import { GeographicalService } from '../../../utils/common';
import { getLocationDetails, removeDuplicates } from '../../../utils/origin-input.util';
import { LocationDetails } from '../../../schemas/Search/Search.schema';
import { getDateTimeByTimezoneInISOStringFormat } from 'app/utils';
import { TIME_ZONE } from 'app/utils/constants';

export const fetchOriginCity = async (value: any,
  setCountry: any,
  setPostalCode: Function,
  clearError: Function,
  onTimeZoneChange: any,
  getLocalTime: any,
  setcurrentLocation: any) => {
  await GeographicalService.details.searchCurrentAddress(
    value,
    async (locations: any) => {
      const [location] = locations;
      const locationDetails = getLocationDetails(location);
      const { cityName, country, postalCode, coords: { lat, lng } = {lat: "", lng: ""}, timeZone } = locationDetails;
      setCountry(country);
      setPostalCode(postalCode);
      setcurrentLocation(locationDetails);
      clearError();
      getLocalTime && getLocalTime(getDateTimeByTimezoneInISOStringFormat());
      onTimeZoneChange &&
        onTimeZoneChange(TIME_ZONE);
    }
  );
};

export const fetchCityList = async (value: any,
  currentLocation: any,
  setOptions: any,
  setShowSuggention: any,
  setSelectedCity: Function,
  setCountry: Function,
  setPostalCode: Function,
  setLatLng: Function,
  clearError: Function,
  onTimeZoneChange: Function | undefined,
  getLocalTime: Function,
  isDestination: boolean,
  useHandler: boolean,
  keyboardshowHandler: any,
  keyboardhideHandler: any) => {
  if (value.length > 2) {
    await GeographicalService.details.searchAddress(value, async (locations: any) => {
      const cityList = locations
        .map((location: any) => getLocationDetails(location))
        .filter(({ cityName }: LocationDetails) => cityName !== currentLocation.cityName);
      const uniqueValues = removeDuplicates(cityList, "cityName");
      setOptions(uniqueValues);
      setShowSuggention(true);
       getKeyBoardHideHandler(isDestination,useHandler,keyboardhideHandler);
      const searchedCity = uniqueValues.find((item: any) => item.cityName === value);
      if (searchedCity) {
        const { cityName, country, postalCode, coords: { lat, lng } = {lat: "", lng: ""}, timeZone } = searchedCity;
        setSelectedCity(cityName);
        setCountry(country);
        setPostalCode(postalCode);
        clearError();
        getLocalTime && getLocalTime(getDateTimeByTimezoneInISOStringFormat());
        onTimeZoneChange &&
          onTimeZoneChange(TIME_ZONE);
        if (lat && lng) {
          setLatLng({ lat, lng });
        }
      }
    });
  } else {
    setShowSuggention(false);
    getKeyBoardHideHandler(isDestination,useHandler,keyboardhideHandler);
  }
};

function getKeyBoardHideHandler(isDestination:boolean,useHandler:boolean,keyboardhideHandler:any){
  if(isDestination && useHandler)
  {
    keyboardhideHandler();
  }
}
export const onFocusOut = (props: any,
  setFocusOut: any,
  setShowSuggention: any,
  options: any,
  selectedCity: any,
  currentLocation: any,
  setShowError: any,
  setErrorValue: any,
  setBackClicked: any,
  setSelectedCity:any,
  select:any,
) => {
  let valueSelected = false;
  setFocusOut(true);
  setShowSuggention(false);
  valueSelected = options.some((item: any) => item.cityName === selectedCity);
  props.isDestination && props.useHandler && props.keyboardhideHandler();
  !select && setSelectedCity("");
  if (!valueSelected) {
    const isCityName : boolean = !(selectedCity === currentLocation.cityName || selectedCity === props.deFaultValue);
    setShowError(isCityName);
    setErrorValue(isCityName, props.InputName);
    const isSelectedCity = selectedCity && selectedCity.length;
    !isSelectedCity && setShowError(!!isSelectedCity) && setErrorValue(true, props.InputName);
  } else {
    setShowError(false);
    setErrorValue(false, props.InputName);
  }
  setBackClicked(false);
};

export const citySelected = async (SearchCity: LocationDetails,
  setSelectedCity: any,
  setCountry: any,
  setPostalCode: Function,
  setShowSuggention: any,
  setSelect: any,
  setLatLng: any,
  props: any) => {
  const { cityName, country = "", postalCode = "", coords: { lat, lng } = { lat: "", lng: "" }, timeZone } = SearchCity;
  setCountry(country);
  setPostalCode(postalCode);
  setShowSuggention(false);
  setSelect(true);
  setSelectedCity(cityName);
  if (props.isDestination && props.useHandler) {
    props.keyboardhideHandler();
  }
  props.getLocalTime &&
    props.getLocalTime(getDateTimeByTimezoneInISOStringFormat());
  props.onTimeZoneChange && props.onTimeZoneChange(TIME_ZONE);
  if (lat && lng) {
    setLatLng({ lat, lng });
  }
};

